<template >
  <div>
    <vue-element-loading
      :active="appLoading"
      spinner="bar-fade-scale"
      color="#1976d2"
      size="128"
      is-full-screen
    />
    <!-- <div class="layout-authi grey lighten-3"> -->
    <v-snackbar v-model="showSnackBar" color="black" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <!-- <div height class="layout-auth layout-auth-background"></div> -->

    <!-- <v-container class=""> -->
    <div height class="layout-auth layout-auth-background2"></div>

    <v-layout pt-12 wrap>
      <v-flex xs12 lg2> </v-flex>
      <v-flex xs12 lg8>
        <v-card tile height="400px" class="mt-12" elevation="24">
          <v-layout fill-height wrap>
            <v-flex xs12 lg6>
              <v-layout class="grey lighten-3" fill-height justify-center wrap>
                <v-flex align-self-center text-center xs12 lg12>
                  <img
                    src="../../assets/Al Sadeel.png"
                    height="auto"
                    width="90%"
                    contain
                  />

                  <h2 class="" style="font-weight:bold; color:#1E147AFF;">
                    Al-Sadeel Admin Panel
                  </h2>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs12 lg6>
              <v-layout fill-height justify-center wrap>
                <v-flex align-self-center xs12 lg12>
                  <v-card-text>
                    <v-alert color="#e7ab5f" type="info">
                      Use Admin credentials to login in
                    </v-alert>

                    <v-form @submit.prevent="validateInput">
                      <v-text-field
                        dense
                        v-model="email"
                        placeholder="Email"
                        prepend-inner-icon="mdi-email"
                        required
                        outlined
                      >
                      </v-text-field>
                      <v-text-field
                        dense
                        type="password"
                        v-model="password"
                        placeholder="Password"
                        prepend-inner-icon="mdi-lock"
                        required
                        outlined
                      >
                      </v-text-field>
                    </v-form>
                    <v-layout v-if="msg2" py-4 wrap>
                      <v-flex text-center>
                        <span
                          style="
                            font-family: poppinslight;
                            font-size: 14px;
                            color: red;
                          "
                          >{{ msg2 }}</span
                        >
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <!-- <v-card-actions> -->
                  <v-row>
                    <v-col class="d-flex px-6" cols="12">
                      <v-btn
                        dark
                        block
                        color="#171519"
                        @click.prevent="validateInput"
                      >
                        <span>Login</span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <!-- </v-card-actions> -->
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 lg2> </v-flex>
    </v-layout>
    <!-- </v-container> -->
    <!-- </div> -->
  </div>
</template>
<script>
import axios from "axios";
import store from "../../store";
export default {
  data() {
    return {
      email: null,
      password: null,
      msg: null,
      msg2: null,
      showSnackBar: false,
      timeout: 5000,
      appLoading: false,
    };
  },
  methods: {
    validateInput() {
      if (!this.email) {
        this.msg = "Please provide Email";
        this.showSnackBar = true;
        return;
      }
      if (!this.password) {
        this.msg = "Please provide Password";
        this.showSnackBar = true;
        return;
      }
      this.loginCheck();
    },
    loginCheck() {
      this.appLoading = true;
      var Data = {};
      Data["email"] = this.email;
      Data["password"] = this.password;
      axios({
        method: "POST",
        url: "/admin/signin",
        data: Data,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("loginUser", true);
            localStorage.setItem("token", response.data.token);
            this.$router.push("/");
          } else {
            this.msg = response.data.msg;
            this.showSnackBar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>

<style lang="sass" scoped>
.layout-auth

    height: 60%
    width: 100%
    position: absolute
    top: 0
    left: 0
    content: ""
    z-index: 0

.layout-authi

    height: 100%
    width: 100%
</style>
<style >
.layout-auth-background {
  background-color: #171515;
}
.layout-auth-background1 {
  background-color: #f0ebeb;
}
.layout-auth-background2 {
  background-image: url("../../assets/images/carousal/carousal0.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.unstyled
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input::-webkit-outer-spin-button,
.unstyled
  .v-input__control
  .v-input__slot
  .v-text-field__slot
  input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  display: none;
}
</style>